module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-800.48cd900f.svg";